// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductStyles } from "@stoneage/Overrides/Components/ProductCarouselProduct";
import { productGridStyles } from "@stoneage/App/SharedStyles/Products/ProductGridStyles";
import { css } from "styled-components";
import { xScreen } from "@stoneage/XDL/Utilities";

productCarouselProductStyles.container = {
    css: css`
        ${productGridStyles.container?.css}
        max-width: 308px;
        width: 100%;

        ${xScreen("lt", "md")} {
            max-width: 100%;
        }
        ${xScreen("lte", "sm")} {
            grid-row: span ${({ gridRowSpan }: any) => gridRowSpan};
        }
    `,
};

productCarouselProductStyles.imageWrapper = {
    ...productGridStyles.imageWrapper,
};

productCarouselProductStyles.productImageStyles = {
    ...productGridStyles.productImageStyles,
};

productCarouselProductStyles.productDescriptionStyles = {
    ...productGridStyles.productDescriptionStyles,
};

productCarouselProductStyles.attributesContainer = {
    ...productGridStyles.attributesContainer,
};

productCarouselProductStyles.attributesStyles = {
    ...productGridStyles.attributesStyles,
};

productCarouselProductStyles.partNumbersContainer = {
    ...productGridStyles.partNumbersContainer,
};

productCarouselProductStyles.productPartNumbersStyles = {};

productCarouselProductStyles.productUnitOfMeasureSelectStyles = {};

productCarouselProductStyles.customPriceStyles = {
    container: {
        css: css`
            ${xScreen("lte", "sm")} {
                grid-column-start: 1;
                grid-column-end: 3;
            }
        `,
    },
};

productCarouselProductStyles.unitOfMeasureWrapper = {
    css: css`
        ${xScreen("lte", "sm")} {
            grid-column-start: 1;
            grid-column-end: 3;
        }
    `,
};

productCarouselProductStyles.addToCartContainer = {
    css: css`
        ${xScreen("lte", "sm")} {
            grid-column-start: 1;
            grid-column-end: 3;
        }
    `,
};

productCarouselProductStyles.clearContainer = {
    css: css`
        display: flex;
        justify-content: flex-end;
        margin-top: 4px;
        ${xScreen("lte", "sm")} {
            grid-column-start: 1;
            grid-column-end: 3;
        }
    `,
};
